import script from "./YearCalendar.vue?vue&type=script&lang=ts&setup=true"
export * from "./YearCalendar.vue?vue&type=script&lang=ts&setup=true"

import "./YearCalendar.vue?vue&type=style&index=0&id=74b8aabd&lang=css&scoped=true"
import "./YearCalendar.vue?vue&type=style&index=1&id=74b8aabd&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74b8aabd"]])

export default __exports__